import { connect } from 'react-redux';

import { StoreState } from '../../../reducers';
import UserAvatar from '../../../components/ProfilePage/UserAvatar';
import { getAvatarUrl } from '../../ProfilePage/selectors';

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		profile: {
			userAvatar: { config: { x, y, width, height } },
		},
	} = state;

	return {
		...ownProps,
		imageSrc: getAvatarUrl(state),
		x,
		y,
		width,
		height,
	};
};

export default connect(mapStateToProps)(UserAvatar);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ProfilePage/UserAvatar/index.tsx